import type { User } from "./user";
import type { Category } from "./category";
import type { FileRecord } from "./file";

export type NeedState =
  | "Iniciado"
  | "Firmado"
  | "Enviado Mail"
  | "Presupuestos"
  | "Presupuestos recibidos"
  | "Completado";

export const NEED_STATE_ORDER: NeedState[] = [
  "Iniciado",
  "Firmado",
  "Enviado Mail",
  "Presupuestos",
  "Presupuestos recibidos",
  "Completado",
];

export const NEED_STATE_COLORS: Record<NeedState, string> = {
  Iniciado: "bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200",
  Firmado: "bg-gray-100 text-gray-800 dark:bg-gray-800 dark:text-gray-200",
  "Enviado Mail": "bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200",
  Presupuestos: "bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-200",
  "Presupuestos recibidos": "bg-purple-100 text-purple-800 dark:bg-purple-900 dark:text-purple-200",
  Completado: "bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200",
};

export interface Need {
  id: number;
  name: string;
  ndesc: string | null;
  state: NeedState;
  amount: number | null;
  createdAt: string;
  endDate: string | null;
  updatedAt: string | null;
  uuid: string | null;
  iatemp: string | null;
  preview: boolean;
  adminUser: User;
  category: Category | null;
  initialFile: FileRecord | null;
  finalFile: FileRecord | null;
  expedienteYear: number | null;
  expedienteLetter: string | null;
  expedienteNumber: number | null;
  expediente: string | null;  // Computed: "2026-A-001"
}

export interface NeedCreate {
  name: string;
  ndesc?: string;
  amount?: number;
  endDate?: string;
  categoryId?: number;
  expedienteLetter?: string;
  expedienteNumber?: number;
}

export interface NeedUpdate {
  name?: string;
  ndesc?: string;
  amount?: number;
  endDate?: string;
  categoryId?: number;
  expedienteLetter?: string;
  expedienteNumber?: number;
}

export interface NeedListResponse {
  items: Need[];
  total: number;
  page: number;
  pageSize: number;
}
